import { j as n } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as i } from "react";
import { m as p } from "./tss-DN0acMKN.mjs";
import { M as d, d as l } from "./constants-CnFYFetN.mjs";
import { S as f } from "./Stack-BsxljEnZ.mjs";
const S = p()(({ mode: o }) => ({
  root: {
    outline: o === d.Dye ? `1px solid ${l.main}` : void 0
  }
})), v = i((o, s) => {
  const { children: t, className: r, component: a = "div", ...e } = o, { classes: m, cx: c } = S();
  return /* @__PURE__ */ n.jsx(f, { className: c(m.root, r), component: a, ...e, "data-fabric-component": "Stack", ref: s, children: t });
});
export {
  v as S
};
//# sourceMappingURL=stack-Bniixiia.mjs.map
